import React from "react";
import { PhotoCameraOutlined } from "@mui/icons-material";
import NavBar from "../../../components/navbar/navbar.component";
import {
  ProfileWrapper,
  ProfileLinkContents,
  Flex,
  Table,
  TableWrapper,
  EditWrapper
} from "./profile.styled";
import { CircularProgress, Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ProfileSideBar from "../../../components/ProfileSideBar/profilesidebar.component";
import { generateAPIKey, getUserAPIKeys, removeUserAPIKey } from "../../../app/features/user";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit } from "@mui/icons-material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { exportMagentoPlugin, exportWoocommercePlugin } from "../../../app/features/Customer/Order/externalFileSlice";


const UserKey = () => {
  const [data, setData] = useState();
  const userObj = JSON.parse(localStorage.getItem("user"));
  console.log("user :>>", userObj)
  const userRole = userObj?.role[0];

  const [readOnly, setReadOnly] = useState(true)
  //const { isLoading } = useSelector((state) => state.getUserAPIKeys);
  const editState = false

  let button;
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [openPluginType, setOpenPluginType] = React.useState(false);
  
  const handleOpenPluginType = () => {
    setOpenPluginType(true);
  };
  const handleClosePluginType = () => {
    setOpenPluginType(false);
  };

  const selectForDelete = (row) => {
    dispatch(removeUserAPIKey(row.id)).then((res) => {
      const { error } = res;
        error ?? alert(error)
        alert("API Key Successfully deleted")
        dispatch(getUserAPIKeys()).then((res) => {
          const { payload, error } = res;
          !error && setData(payload)
        })
    });
  }

  const addKey = () => {
    dispatch(generateAPIKey()).then((res) => {
      const { error } = res;
        error != undefined ?? alert(error)
        alert("API Key Successfully created")
        dispatch(getUserAPIKeys()).then((res) => {
          const { payload, error } = res;
          !error && setData(payload)
        })
    });
  }
  const handleWooDownload = () => {
      dispatch(exportWoocommercePlugin()).then( res => {
        const { payload, error } = res;
        if (!error) {
          console.log(payload)
          let url = window.URL.createObjectURL(payload.data);
          const link = document.createElement('a');
          link.href = url;
          link.download = "WoocommercePlugin_Redspeed.zip"; // Sets the filename

          // 5. Append to DOM, trigger download, and clean up
          document.body.appendChild(link);
          link.click();
      
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          toast(error)
        }
      })
    }

  const handleMagDownload = () => {
      dispatch(exportMagentoPlugin()).then( res => {
        const { payload, error } = res;
        if (!error) {
          console.log(payload)
          let url = window.URL.createObjectURL(payload.data);
          const link = document.createElement('a');
          link.href = url;
          link.download = "MagentoPlugin_Redspeed.zip"; // Sets the filename

          // 5. Append to DOM, trigger download, and clean up
          document.body.appendChild(link);
          link.click();
      
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          toast(error)
        }
      })
    }

  useEffect(()=>{
    dispatch(getUserAPIKeys()).then((res)=> {
      const {payload, error} = res
      !error && setData(payload)
    })

  }, [])

  return (
    <>
      <NavBar />

      <div className="main-content main-content-margin-top">
        <ProfileWrapper>
          <ProfileSideBar />
          <ProfileLinkContents>
            <p style={{ fontSize: "1.5em", margin: "8px 0" }}>
            <i onClick={() => navigate(-1)}>
            <ArrowBackIcon /></i>  API Keys</p>
            <hr />

              <EditWrapper>

              <Button onClick={() => handleOpenPluginType()} variant="outlined">
              Download Plugin
              </Button>
              <Button onClick={() => addKey()} variant="outlined">
              Generate Key
              </Button>
              
              </EditWrapper>

              <TableWrapper>
            <Table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Key</th>
                  <th>Expiry Date</th>
                  <th>Status</th>
                  
                </tr>
              </thead>
              {
                <tbody>
                {data?.map((row_, Key) => {
                    return (
                      <tr>
                        <td>{row_.id}</td>
                        <td>{row_?.key}</td>
                        <td>{row_?.expiryDate ? new Date(row_.expiryDate).toDateString() : '-'}</td>
                        <td>{row_?.status == 0 ? 'Active' : 'Disabled'}</td>
                        
                        <td>
                          <Flex>
                            {" "}
                            <div onClick={()=> selectForDelete(row_)} className="red">
                              <DeleteIcon />
                            </div>
                          </Flex>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
}
            </Table>
            {/* {isLoading && <Button style={{width:'100%', marginTop:'20px'}}><CircularProgress/></Button>} */}
          </TableWrapper>
          </ProfileLinkContents>
        </ProfileWrapper>
      </div>
      <div name="Order Type">
              <Dialog open={openPluginType} onClose={handleClosePluginType}>
                <Box
                  style={{ marginTop: "10px" }}
                  sx={{
                    maxWidth: "auto",
                    display: "flex",
                  }}
                >
                  <Button style={{}} onClick={handleClosePluginType} color="error">
                    <KeyboardBackspaceIcon />
                  </Button>
                  <DialogTitle style={{ paddingLeft: "0" }}>
                    Select CMS Plugin Type
                  </DialogTitle>
                </Box>
                <DialogContent>
                  <Box>
                    <p> Documentation inclusive. Download and Extract to get it</p>
                    <Button
                      style={{
                        textTransform: "capitalize",
                        fontWeight: "700",
                        marginBottom: "5px",
                      }}
                      variant="outlined"
                      color="error"
                      sx={{ width: "100%" }}
                      onClick={() => handleWooDownload()}
                    >
                      Woocommerce Plugin
                    </Button>
                    <Button
                      style={{
                        textTransform: "capitalize",
                        fontWeight: "700",
                        marginBottom: "5px",
                      }}
                      variant="outlined"
                      color="error"
                      sx={{ width: "100%" }}
                      onClick={() => handleMagDownload()}
                    >
                      Magento Plugin
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </div>
    </>
  );
};

export default UserKey;
